import React, { useRef, useEffect, useContext } from 'react';
import auditDrop from '../../images/icons/auditDrop.svg';
import CommonCheckbox from '../../common/components/CommonCheckBox/CommonCheckbox';
import * as _ from 'lodash';

const FilterOptionsInPrinciple = ({
  filterMenu,
  setShowOptions,
  propsFromFormik,
  setFilteredData,
  addFilter,
  multiSelect,
  resetFilter,
  filterContainerStyle = { maxHeight: '85vh' },
  filterListsStyle = {},
  setFormikFilterData,
  resetHandler,
  applyHandler
}) => {
  const { values: data, dirty, resetForm, setFieldValue } = propsFromFormik;
  const linkRef = useRef([]);
  const myRefs = useRef([]);
  const arrowRefs = useRef([]);
  useEffect(() => {
    if (dirty) {
      filterMenu.map((el, i) => {
        if (!Object.keys(data[el?.name] || {}).every(k => !data[el.name][k])) {
          if (!myRefs?.current[i]) return;
          myRefs.current[i].style.display = 'flex';
          arrowRefs.current[i].classList.remove('rotate-180');
          arrowRefs.current[i].classList.add('rotate-0');
        }
      });
    }
  }, [dirty]);

  return (
    <div
      className="md:w-81 bg-white shadow-md absolute z-50 mt-9 self-start pb-5  overflow-auto rounded  "
      style={filterContainerStyle}
      onClick={e => e.stopPropagation()}
    >
      <ul className="p-3 flex flex-col justify-between space-y-4   ">
        {filterMenu.map(({ name, type, dropdown, singleSelect }, i) => (
          <li
            key={i}
            ref={el => (linkRef.current[i] = el)}
            className="text-black-1003    "
          >
            <div
              className="flex flex-row justify-between pr-6 font-medium"
              onClick={() => {
                if (myRefs.current[i].style.display === 'flex')
                  myRefs.current[i].style.display = 'none';
                else {
                  myRefs.current[i].style.display = 'flex';
                }
                if (arrowRefs.current[i].classList.contains('rotate-180')) {
                  arrowRefs.current[i].classList.remove('rotate-180');
                  arrowRefs.current[i].classList.add('rotate-0');
                } else {
                  arrowRefs.current[i].classList.remove('rotate-0');
                  arrowRefs.current[i].classList.add('rotate-180');
                }
              }}
            >
              <p>{name}</p>
              <img
                ref={el => (arrowRefs.current[i] = el)}
                src={auditDrop}
                className="transform rotate-180 "
                alt="^"
              />
            </div>

            {dropdown && dropdown.length ? (
              <>
                <ul
                  style={{ display: 'none ', ...filterListsStyle }}
                  className={'flex flex-col justify-between space-y-3 pt-3'}
                  ref={el => (myRefs.current[i] = el)}
                >
                  {dropdown.map(({ title, htmlTitle }, i) => {
                    if (type === 'check') {
                      return (
                        <li key={i} className=" flex flex-row justify-between">
                          <p className="text-black-400 text-sm">
                            {htmlTitle ? htmlTitle : title}
                          </p>
                          <CommonCheckbox
                            checked={
                              data[name]
                                ? data[name][
                                    window['Obj2Arr_' + name + '[' + i + ']']
                                  ]
                                : false
                            }
                            name={name}
                            value={
                              data[name]
                                ? data[name][
                                    window['Obj2Arr_' + name + '[' + i + ']']
                                  ]
                                : ''
                            }
                            onChange={async e => {
                              let temp = Object.assign({}, data[name]);
                              if (
                                !multiSelect ||
                                name === 'Product' ||
                                singleSelect
                              ) {
                                temp = _.mapValues(temp, () => false);
                              }
                              temp[window['Obj2Arr_' + name + '[' + i + ']']] =
                                e.target.checked;

                              setFieldValue(`${name}`, temp);
                            }}
                          />
                        </li>
                      );
                    }
                  })}
                </ul>
              </>
            ) : null}
          </li>
        ))}
      </ul>
      {dirty ? (
        <div className="self-end flex flex-row w-48 ml-auto mr-3">
          <button
            className="block text-sm mx-auto  leading-none py-3 px-4 rounded mt-2  text-white h-10 w-22 bg-red-500"
            onClick={resetHandler}
          >
            Reset
          </button>

          <button
            onClick={applyHandler}
            className="block text-sm mx-auto  leading-none py-3 px-4 rounded mt-2  text-white h-10 w-22 bg-teal "
          >
            Apply
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default React.memo(FilterOptionsInPrinciple);
